<template>
    <div id="contact-page">
        <app-flex-header></app-flex-header>
        <div v-if="items.page" class="columns has-text-centered p-centered-40">
            <div class="column is-one-half" id="weather">
                <div class="mt-80" v-html="items.page.description"></div>
            </div>

            <div class="column is-one-half">
                <app-contact-form class="mtb-120"></app-contact-form>
            </div>
        </div>

        <div v-if="items.post" class="columns testi-container limegreen-panel">
            <div class="column is-one-third">
                <!-- <figure v-html="imageUrl" class="item quote-img"></figure> -->
                <blockquote class="mt-100">
                    <span>{{ items.quote.quote }}</span>
                    <cite>{{ items.quote.author }}</cite>
                </blockquote>
            </div>

            <div class="column is-one-third">
                <h3 class="complex-line mt-80" title="Vreme danes"><span class="related weather"></span></h3>
                <app-weather language="sl-si" title="Vreme danes"></app-weather>
            </div>

            <div class="column is-one-third post-content">
                <h3 class="is-4"> <a :href="items.post.link">{{ items.post.title }}</a> </h3>
                    <div v-html="items.post.content"></div>
                    <a class="general-link" href="/blog">Vsi članki</a>
            </div>
        </div>

        <section  v-if="items.page" class="section full">
            <!-- <div v-html="items.page.description"></div> -->
            <app-google-map mapName="('contact')"></app-google-map>
        </section>
    </div>
</template>

<script>
import { ApiHome, PhotoUrl } from '../.env';
import { mapGetters } from 'vuex';
import GoogleMaps from '../components/elements/gmaps/GoogleMaps.vue';
import FlexHeaderBar from '../components/layout/FlexHeaderBar';
import Weather from '../components/elements/weather/Weather';
import ContactForm from '../components/elements/form/ContactForm';

export default {
    data() {
        return {
            endpoint: ApiHome + 'contact',
        }
    },

    components: {
        'app-google-map': GoogleMaps,
        'app-weather': Weather,
        'app-flex-header': FlexHeaderBar,
        'app-contact-form': ContactForm,
    },

    computed: {
        ...mapGetters([
            'items',
        ]),
    },

    methods: {
        fetchContact() {
            this.$store.dispatch('fetchItems', this.endpoint);
        },
    },

    mounted() {
        this.fetchContact();
        // console.log('Contact - Component mounted.')
    }
}
</script>

<style lang="scss">

.title{
    font-weight: 300;
}

.map-frame {
    height:800px !important;
    #google-map {
        height: 800px !important;
    }
}

.section.full {
    padding: 3rem 0 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/Contact.vue